import { render, staticRenderFns } from "./MainTextAndCards.vue?vue&type=template&id=7d210624&scoped=true&"
import script from "./MainTextAndCards.vue?vue&type=script&lang=js&"
export * from "./MainTextAndCards.vue?vue&type=script&lang=js&"
import style0 from "./MainTextAndCards.vue?vue&type=style&index=0&id=7d210624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d210624",
  null
  
)

export default component.exports